import axios from '../util/axiosConfig';
// import fileDownload from "js-file-download";
import { message } from 'antd';

import { getErrorMessage } from '../util/ErrorUtils';




// export const changePasswordAPI = async (user) => {
//     return await axios.post(`/api/v1/user/change-password`, user)
//         .then(function (response) {
//             if (response.data) {
//                 return { success: true, data: response.data };
//             } else {
//                 return { success: false };
//             }
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 return { success: false, data: error.response.data.message };
//             }
//             else {
//                 return { success: false, data: 'Error occurred while changing password!' };
//             }

//         });
// }


export const getAllUsers = async (payload) => {
    let data = {
            ...payload,
            pageNo: payload.pageNo - 1,
            pageSize: payload.pageSize
        }
    return await axios.post(`/api/v1/admin/users`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const registerUser = async (user) => {
    return await axios.post(`/api/v1/admin/add-user`, user)
        .then(function (response) {
            if (response.data) {
                return { success: true, user: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

// export const updateUserSitesAPI = async (sites) => {
//     return await axios.post(`/api/v1/admin/update-site-assignment`, sites)
//         .then(function (response) {
//             if (response.data) {
//                 return { success: true, sites: response.data };
//             } else {
//                 return { success: false };
//             }
//         })
//         .catch(function (error) {
//             return { success: false, error };
//         });
// }

export const updateUserAccountAPI = async (userAccount) => {
    return await axios.post(`/api/v1/admin/update-user-account`, userAccount)
        .then(function (response) {
            if (response.data) {
                return { success: true, userAccount };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const resetUserPasswordAPI = async (email) => {
    return await axios.get(`/api/v1/admin/reset-user-password`, {
        params: {
            'email': email
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, accountInfo: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const changePasswordAPI = async (user) => {
    return await axios.post(`/api/v1/user/change-password`, user)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            if (error.response) {
                return { success: false, data: error.response.data.message };
            }
            else {
                return { success: false, data: 'Error occurred while changing password!' };
            }

        });
}

export const getAllTechniciansAPI = async (siteId) => {
    return await axios.get(`/api/v1/technicians`, {
        params: {
            'siteId': siteId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, technicians: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getAllDoctorsAPI = async () => {
    return await axios.get(`/api/v1/doctors`)
        .then(function (response) {
            if (response.data) {
                return { success: true, doctors: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getAllLoggedInUsers = async (user) => {
    return await axios.get(`/api/v1/admin/logged-in-users`, user)
        .then(function (response) {
            if (response.data) {
                return { success: true, users: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getRisUsersWithMipsAPI = async (userId) => {

    return await axios.get(`/api/v1/admin/ris-users-with-mips`, {
        params: {
            userId: userId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const createRisUserAPI = async (data) => {
    return await axios.post(`/api/v1/admin/create-ris-user`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, risUserMips: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const updateRisUserAPI = async (risUser) => {
    return await axios.post(`/api/v1/admin/update-ris-user`, risUser)
        .then(function (response) {
            if (response.data) {
                return { success: true, risUser: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deleteRisUserAPI = async (userId, risId) => {
    return await axios.delete(`/api/v1/admin/delete-ris-user`, {
        params: {
            userId,
            risId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUpdateRisUserMipsAPI = async (data) => {
    return await axios.post(`/api/v1/admin/add-update-ris-user-mips`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, risUserMips: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

// export const downloadInstallerAPI = (installerName, onComplete) => {
//     return axios
//         .get(`/radiscan-storage/${installerName}`, {
//             responseType: 'blob'
//         })
//         .then(function (response) {
//             if (response.status == 200) {
//                 fileDownload(response.data, installerName);
//             } else {
//                 message.error('Failed to download file!');
//             }
//             onComplete(installerName);
//         })
//         .catch(function (error) {
//             onComplete(installerName);
//             message.error('Failed to download file!');
//         });
// }

export const getUserAllowedRisWithMipsAPI = (sessionRole) => {
    return axios
        .get(`/api/v1/user/allowed-ris-with-mips`, {
            params: {
                sessionRole
            }
        })
        .then(function (response) {
            if (response.data) {
                return { success: true, risWithMips: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            message.error('Failed to download file!');
        });
}

export const unAssignUserMipAPI = (userMipId) => {
    return axios.delete(`/api/v1/admin/unassign-user-mip/${userMipId}`, {
        params: {
            "id": userMipId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchRolesAPI = async () => {
    return await axios.get(`/api/v1/admin/roles`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchSkillsAPI = async () => {
    return await axios.get(`/api/v1/admin/skills`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchUserSkillsAPI = async (userId) => {
    return await axios.get(`/api/v1/admin/users/${userId}/userskills`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUserSkillsAPI = async (userSkill) => {
    return await axios.get(`/api/v1/admin/userskills`, {
        params: {
            userId: userSkill.userId,
            skillId: userSkill.skillId,
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deleteUserSkillsAPI = async (userSkill) => {
    return await axios.delete(`/api/v1/admin/userskills/${userSkill.userSkillId}`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchUserMipsAPI = async (userId) => {
    return await axios.get(`/api/v1/users/${userId}/user-mips`, {
        params: {
            userId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const assignUserMipsAPI = async (assignUserMipParam) => {
    return await axios.post(`/api/v1/admin/assign-user-mip`, assignUserMipParam)
        .then(function (response) {
            if (response.data) {
                return { success: true, userMip: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const updateUserMipsAPI = async (userMips) => {
    return await axios.post(`/api/v1/admin/user-mips`, userMips)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const resetAuthenticatorQrAPI = async(userId) => {
    return await axios.get(`/api/v1/reset-qr?userId=${userId}`)
        .then(function (response) {            
            if (response.status === 200) {
                return { success: true};
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}